import React, { useState, useContext, useRef }from "react";
import {Formulario} from "../../globals/dhtmlx/Form";
import Button from "../../globals/Button";
import FormErrorMessage from "../../globals/FormErrorMessage";
import {SesionContext} from '../../../context/SesionContext';
import { useHistory, Link } from "react-router-dom";
import { apiCall } from "../../../helpers/ApiCalls";
import styled from "styled-components";
import ReCAPTCHA from 'react-google-recaptcha';
import "../../../dhtmlx/codebase/suite.css";
import "./form.css";

const recaptcha_key = process.env.REACT_APP_RECAPTCHA;
/**ESTILOS */
  const Container = styled.section`
    width: 100%;
    display: ${props => props.show};
    justify-content: center;
    align-content: center;
    height: auto;
    padding: 16px 0 16px 0;
  `;
  const LoginMessage = styled.span`
  color: red;
  text-align: center;
  font-size: 18px;
  `;
function LogIn(props){
  let history = useHistory();

  /** CONSTANTES */

  const rows = [
    {
      id: "email",
      type: "input",
      label: "Email",
      placeholder: "jd@mail.name",
      preMessage: "Enter Email",
      errorMessage: "Ingresa un email",
      successMessage: "Email valido",
      validation: "email",
      required: true,
    },
    {
      id: "password",
      type: "input",
      inputType: "password",
      label: "Contraseña",
      placeholder: "********",
      errorMessage: "Ingresa la contraseña",
      required: true,
    },
    
  
  ];

  const {crearSesion} = useContext(SesionContext);
  
  const [inputs, setInputs] = useState({});
  const [valid, setValid] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [showLoginMessage, setShowLoginMessage] = useState(false);
  const [captchaValido, setCaptchaValido] = useState(process.env.REACT_APP_ENTORNO ==='Dev'?true:false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const captcha = useRef(null);
  async function iniciarSesion(){
    setButtonLoading(true);
    if(captchaValido && valid && Object.keys(inputs).length >0){
      //hacemos la llamada a la API de
      await apiCall('POST','login',inputs).then((res)=>{
        if(res.success && res.code === 200){
          crearSesion(res.data);
          history.push('/');
          return true;
         
        }
        if(res){
          setLoginMessage(res.message);
        }
        else{
          setLoginMessage("Tenemos problemas, por favor intenta mas tarde.");
        }
        setShowLoginMessage(true);
        setButtonLoading(false);

        return true;
      });
      
    }else{
      if(!captchaValido){
        setLoginMessage("Por favor valida tu identidad");
        setShowLoginMessage(true);
      }
      setButtonLoading(false);
    }
    
  }
  
  function changeCaptcha (){
    if(captcha.current.getValue()){
      setCaptchaValido(true);
    }
    else{
      setCaptchaValido(false);

    }
  }
  return (
    <Container id={'login-container'} show={props.show?'grid':'none'}>
      <Formulario
        rows={rows}
        padding = {0}
        width = {'300px'}
        toggleInputs = {setInputs}
        toggleValid = {setValid}
        toogleMessage = {setShowLoginMessage}
        loading = {buttonLoading}
      />
      <div id="google_recaptcha" style={{margin:'-16px 0 16px 0'}}>
        { process.env.REACT_APP_ENTORNO ==='Dev'?(<></>):(<ReCAPTCHA
          ref={captcha}
          sitekey={recaptcha_key}
          onChange={changeCaptcha}
        />)}
      </div>
      <Button width={'100%'} flat = {true} onClick={iniciarSesion} loading={buttonLoading}>Ingresar</Button>
      <Link to="/reset_password">
        <Button width={'100%'}>
          Olvide mi contraseña
        </Button>
      </Link>
      <FormErrorMessage 
        id="login_message"
        showMessage={showLoginMessage}
        message={loginMessage}
        toggleMessage = {setShowLoginMessage}
        width={'300px'}
      />
    </Container>
    
  );
}
export default LogIn; 